'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var userJourneySessionKey = 'userJourney';
var popupJourneySessionKey = 'popupJourney';
var journeyStringDelimiter = ',';

var userJourneyHandler = {
    getJourney: function getJourney(sessionKey) {
        var string = window.sessionStorage.getItem(sessionKey);
        return string ? string.split(journeyStringDelimiter) : [];
    },
    setJourney: function setJourney(sessionKey, journeyArray) {
        // on iOS in private mode is restricted to write session storage items
        try {
            window.sessionStorage.setItem(sessionKey, journeyArray.join(journeyStringDelimiter));
        } catch (error) {
            console.warn(error);
        }
    },
    getLastArrayItem: function getLastArrayItem(array) {
        return array[array.length - 1];
    },
    getLastUserJourneyEntry: function getLastUserJourneyEntry() {
        var journeyArray = this.getJourney(userJourneySessionKey);
        return this.getLastArrayItem(journeyArray);
    },
    getWindowLocation: function getWindowLocation() {
        var location = window.location.pathname;
        if (/\/search\//.test(window.location.pathname)) {
            location = '' + window.location.pathname + window.location.search;
        }
        if (window.location.hash) {
            location = '' + location + window.location.hash;
        }
        return location;
    },
    trackJourney: function trackJourney(lastOpenedHref) {
        var userJourney = this.getJourney(userJourneySessionKey);
        var popupJourney = this.getJourney(popupJourneySessionKey);
        if (!userJourney.length || this.getLastArrayItem(userJourney) !== this.getWindowLocation()) {
            userJourney.push(this.getWindowLocation());
            this.setJourney(userJourneySessionKey, userJourney);
            popupJourney.push(lastOpenedHref);
            this.setJourney(popupJourneySessionKey, popupJourney);
        }
    },
    removeLastJourneyEntry: function removeLastJourneyEntry() {
        var userJourney = this.getJourney(userJourneySessionKey);
        var popupJourney = this.getJourney(popupJourneySessionKey);
        userJourney.pop();
        popupJourney.pop();
        this.setJourney(userJourneySessionKey, userJourney);
        this.setJourney(popupJourneySessionKey, popupJourney);
    },
    getLastJourneyEntry: function getLastJourneyEntry(sessionKey) {
        var journeyArray = this.getJourney(sessionKey);
        return this.getLastArrayItem(journeyArray);
    },
    isJourneyValid: function isJourneyValid() {
        var lastPopupJourneyEntry = this.getLastJourneyEntry(popupJourneySessionKey);
        var journeyLength = this.getJourney(userJourneySessionKey).length;
        var lastUserJourneyEntry = this.getLastJourneyEntry(userJourneySessionKey);
        var locationPathname = this.getWindowLocation();
        var lastPopupJourneyBase = lastPopupJourneyEntry ? lastPopupJourneyEntry.split('/', 2).pop() : '';
        lastPopupJourneyEntry = lastPopupJourneyEntry ? lastPopupJourneyEntry.replace(/#.*/g, '') : lastPopupJourneyEntry;
        var lastUserJourneyBase = lastUserJourneyEntry ? lastUserJourneyEntry.split('/', 2).pop() : '';

        return journeyLength && (lastPopupJourneyBase !== lastUserJourneyBase || lastPopupJourneyBase === 'profile' || lastPopupJourneyBase === 'tipping') && locationPathname.indexOf(lastPopupJourneyEntry) === 0;
    },
    handleSwiftypePopup: function handleSwiftypePopup() {
        var lastPopupJourneyEntry = this.getLastJourneyEntry(popupJourneySessionKey);
        if (/api.swiftype.com/.test(lastPopupJourneyEntry)) {
            var popupJourney = this.getJourney(popupJourneySessionKey);
            popupJourney[popupJourney.length - 1] = this.getWindowLocation();
            this.setJourney(popupJourneySessionKey, popupJourney);
        }
    },
    resetAllJourneys: function resetAllJourneys() {
        this.setJourney(userJourneySessionKey, []);
        this.setJourney(popupJourneySessionKey, []);
    },
    isDirectAccess: function isDirectAccess() {
        return !window.document.referrer;
    }
};

exports.default = userJourneyHandler;


//////////////////
// WEBPACK FOOTER
// ./~/rp-popup/lib/journeyHandler.js
// module id = 995
// module chunks = 1